import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import ComicCard from "@/components/feature/ComicCard";

interface EmptyStateProps {
  title: string;
  desc: string;
  onReset?: () => void;
  resetLabel?: string;
  recommendations?: Comic[];
}

export default function EmptyState({
  title,
  desc,
  onReset,
  resetLabel = "重置筛选条件",
  recommendations = [],
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center">
      <div className="w-full flex flex-col items-center text-center py-14 px-4 rounded-xl bg-background-50 border border-dashed border-background-300">
        <span className="w-16 h-16 rounded-xl bg-background-100 text-foreground-400 flex items-center justify-center">
          <i className="ri-search-eye-line text-3xl"></i>
        </span>
        <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">{title}</h3>
        <p className="mt-2 text-sm text-foreground-500 max-w-md">{desc}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {onReset && (
            <button
              type="button"
              onClick={onReset}
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-refresh-line"></i>
              {resetLabel}
            </button>
          )}
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览全部分类
          </Link>
        </div>
      </div>

      {recommendations.length > 0 && (
        <div className="w-full mt-10">
          <h3 className="font-heading font-bold text-lg text-foreground-950 mb-5">
            <i className="ri-magic-line mr-1.5 text-primary-500"></i>
            为你推荐
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
            {recommendations.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}